import {
    optionTitle_safeSendersDomains,
    optionSearchTerms_safeSendersDomains,
} from './SafeSendersDomainsOptionV2.locstring.json';
import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
import { IsShadowMailboxUser } from 'owa-mail-ads-shared/lib/sharedAdsUtils';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
const SafeSendersDomainsOptionV2: LazyOption = createLazyOption(
    {
        key: 'safeSendersDomainsV2',
        titleStringKey: optionTitle_safeSendersDomains,
        searchTermsStringKey: optionSearchTerms_safeSendersDomains,
        isHidden: () => {
            return IsShadowMailboxUser();
        },
    },
    lazyFullModule,
    m => m.default
);
export default SafeSendersDomainsOptionV2;
